import { createSlice } from '@reduxjs/toolkit';

import { reducers } from './reducers';
import { SliceState } from './slice-state';

const initialState: SliceState = {};

const sliceObj = createSlice({
    name: 'crowd',
    initialState,
    reducers,
});

// register this in your root state
export const CrowdSliceReducer = sliceObj.reducer;

export const {
    // list of exported actions here
    setSomething,
} = sliceObj.actions;
